import {Button, DatePicker, EMPHASIS} from '@forecast-it/design-system';
import React from 'react';
import styled from 'styled-components';

const DatePickerWithButtonsStyle = styled.div`
	display: flex;
	gap: 4px;
`;

type DatePickerWithButtonsProps = {
	value: string;
	dataCy?: string;
	onDatePickerChange: (dateString: string) => void;
	onBackButton: () => void;
	onForwardButton: () => void;
};
const DatePickerWithButtons = ({
	value,
	onDatePickerChange,
	onBackButton,
	onForwardButton,
	dataCy,
}: DatePickerWithButtonsProps): JSX.Element => {
	return (
		<DatePickerWithButtonsStyle>
			<Button
				data-cy={`${dataCy}-back-button`}
				onPress={onBackButton}
				emphasis={EMPHASIS.MONO}
				icon={'chevronLeft'}
				iconOnly
			/>
			<DatePicker value={value} onChange={onDatePickerChange} data-cy={dataCy} aria-label="date-picker" />
			<Button
				data-cy={`${dataCy}-foward-button`}
				onPress={onForwardButton}
				emphasis={EMPHASIS.MONO}
				icon={'chevronRight'}
				iconOnly
			/>
		</DatePickerWithButtonsStyle>
	);
};

export default DatePickerWithButtons;
